import { FC } from "react";
import { ScrollView } from "react-native";

import { HStack, Pressable, Text } from "@/components/ui";

interface CellTabBarProps {
  labels: string[];
  onChange: (index: number) => void;
  selected: number;
}

/* Horizontal tab bar used in the detailed view of a use-case section
   to filter results by rotation cell. Mirrors the styling of the
   in-card graph/summary/verbatims tabs in `QuestionResults` so the
   two feel like the same control surface. The bar scrolls
   horizontally when there are many cells (e.g. a MaxDiff section
   with several tasks) so labels are never truncated. */
const CellTabBar: FC<CellTabBarProps> = ({ labels, onChange, selected }) => (
  <ScrollView
    contentContainerStyle={{ paddingHorizontal: 0 }}
    horizontal
    showsHorizontalScrollIndicator={false}
    // Without an explicit flex chain the ScrollView on React Native Web
    // sizes to its content width and the parent flex-1 wrapper stops
    // clipping — leading to a first tab that visually bleeds past the
    // detail button. `flexShrink: 1` + `minWidth: 0` lets the scroll
    // viewport shrink to whatever the flex-1 wrapper allocates, so the
    // tabs scroll horizontally instead of overflowing.
    style={{ flexGrow: 0, flexShrink: 1, minWidth: 0 }}
  >
    <HStack
      style={{
        backgroundColor: "hsl(220,13%,91%)",
        borderRadius: 8,
        gap: 2,
        padding: 2,
      }}
    >
      {labels.map((label, index) => {
        const isActive = index === selected;
        return (
          <Pressable
            key={index}
            onPress={() => onChange(index)}
            style={{
              backgroundColor: isActive ? "white" : "transparent",
              borderRadius: 6,
              paddingHorizontal: 12,
              paddingVertical: 6,
            }}
          >
            <Text
              className="text-xs font-medium"
              style={{
                color: isActive ? "hsl(220,13%,13%)" : "hsl(220,13%,46%)",
              }}
            >
              {label}
            </Text>
          </Pressable>
        );
      })}
    </HStack>
  </ScrollView>
);

export default CellTabBar;
